import React, {Component} from "react";
import PropTypes from "prop-types";
import FormSearch from "./FormSearch";
import TrademarkResults from "./TrademarkResults";
import {_checkTradeMark} from "../../services/TrademarkServices";
import {insertNewHistory} from "../../services/HistoryServices";
import changeQuerySearch from "../../helpers/routes/changeQuerySearch";
import {withRouter} from "react-router-dom";

class SearchTradeMarks extends Component {
    state = {
        error: '',
        results: [],
        loading: false,
        term: '',
    };

    render() {
        const {results, term, loading} = this.state;

        return (
            <div className="SearchTradeMarks col-md-9 col-sm-12">
                <FormSearch onSubmit={this._handleOnSubmit.bind(this)}/>

                <TrademarkResults loading={loading} term={term} results={results}/>
            </div>
        );
    }

    _handleOnSubmit(text) {
        this.setState({
            loading: true,
            term: text
        });

        const {history} = this.props;
        changeQuerySearch(history)({term: text});

        return _checkTradeMark(text)
            .then(response => {
                const {success, data, message} = response;

                if (success) {
                    insertNewHistory(text);

                    this.setState({
                        results: data,
                        error: '',
                        loading: false
                    });
                } else {
                    this.setState({
                        error: message,
                        loading: false
                    });
                }

                return Promise.resolve(response);
            })
            .catch(error => {
                const message = error.message || error;

                this.setState({
                    loading: false,
                    error: message
                });

                return Promise.reject(error);
            });
    }
}

SearchTradeMarks.propTypes = {
    history: PropTypes.object.isRequired
};

export default withRouter(SearchTradeMarks);


// WEBPACK FOOTER //
// ./src/app/home/SearchTradeMarks.js